angular.module 'app'
.controller 'ExternalLinkController', ($scope, $http, $state, $sce, $stateParams, $ionicPopup, config, activeUser) ->
  $scope.ui =
    baseUrl: config.api.baseUrl
    homepage: activeUser.homepage
    title: ''
    userInfo: activeUser.user
    column: {}

  do findColumn = ->
    $http.get "#{config.api.baseUrl}/cumpus/programa/#{$stateParams.column_id}", {}
    .then (res) ->
      $scope.ui.column = res.data
      $scope.ui.title = $scope.ui.column.programa_name
    .catch (error) ->
      $ionicPopup.alert(
        title: "錯誤"
        template: "系統出錯！"
        buttons: [
          {text: '<b>關閉</b>', type: 'button-positive'}
        ]
      )

  $scope.trustSrc = (url) ->
    $sce.trustAsResourceUrl url